import { type PropsWithChildren, useEffect } from 'react';
import { createPortal } from 'react-dom';

import { css } from '@/utils';
import { Icon } from '../Icon';
import styles from './styles.module.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  maximized?: boolean;
}

export const Modal = (props: PropsWithChildren<Props>) => {
  const modalRoot = document.getElementById('modal-root');

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') props.onClose();
    };
    if (props.isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden'; // Prevent background scroll
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [props]);

  if (!props.isOpen || !modalRoot) {
    return null;
  }

  return createPortal(
    <div className={styles.modalOverlay} onClick={props.onClose} role='dialog' aria-modal='true'>
      <div
        className={css(styles.modalContainer, props.maximized ? styles.maximized : '')}
        onClick={(e) => e.stopPropagation()}
        role='document'>
        <div className={styles.modalCloseBtn} onClick={props.onClose} role='button' aria-label='Close modal'>
          <Icon name='close' size={20} />
        </div>
        {props.children}
      </div>
    </div>,
    modalRoot
  );
};
